// components/Image.tsx
import React from 'react';

interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  alt: string;
  width?: number | string;
  height?: number | string;
  className?: string;
  fallbackSrc?: string;
}

const Image: React.FC<ImageProps> = ({ src, alt, width, height, className, fallbackSrc, onError, ...rest }) => {
  const handleError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    if (fallbackSrc) {
      const target = e.target as HTMLImageElement;
      if (target.src !== fallbackSrc) {
        target.src = fallbackSrc;
      }
    }
    onError?.(e);
  };

  return (
    <img
      src={src}
      alt={alt}
      width={width}
      height={height}
      className={className}
      onError={fallbackSrc || onError ? handleError : undefined}
      {...rest}
    />
  );
};

export default Image;
